<template>
  <v-row class="pa-0 ma-0" align="center" justify="center">
    <v-btn absolute right bottom small fab color="white" @click.stop="onPrint()" class="print-btn"><v-icon>mdi-printer</v-icon></v-btn>
    <v-col cols="12" class="pa-0">
      <v-row class="pa-0 ma-0" align="center" justify="center">
        <v-col :cols="edit ? '9' : '12'" class="pa-0">
          <v-row class="pa-0 ma-0" align="center" justify="center">
            <v-col cols="3" class="pa-0">
              <v-row class="pa-0 ma-0" align="center">
                <v-col cols="4" class="pa-0">
                  <v-row class="pa-0 ma-0" align="center">
                    <v-col cols="8" class="pa-0">
                      <v-sheet tile color="primary" class="L-T">
                        <span class="white--text">{{ month }}</span>
                      </v-sheet>
                    </v-col>
                    <v-col class="pa-0 hidden-xs-only">
                      <v-sheet tile color="primary" class="L-T">
                        <span class="white--text">_</span>
                      </v-sheet>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="8" class="pa-0">
                  <v-sheet tile color="primary" class="L-R-T">
                    <span class="white--text">イベント</span>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="9" class="pa-0" style="overflow-y: scroll;">
              <v-row class="pa-0 ma-0" align="center" justify="center">
                <v-col cols="3" class="pa-0" v-for="item in $DESCRIPTIONS_ITEMS" :key="item.id">
                  <v-sheet tile :color="item.color" style="text-align: center;" class="R-T">
                    <span class="white--text">{{ item.name }}</span>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="edit" cols="3" class="pa-0 scroll-y">
          <v-toolbar flat color="primary" height="22">
            <span class="white--text">雛形</span>
            <v-spacer></v-spacer>
            <v-btn rounded x-small depressed @click="onChangeCategory()"><span class="font-weight-bold primary--text">{{ menuSort == 'category' ? '時間' : '種別' }}</span></v-btn>
          </v-toolbar>
        </v-col>

        <v-col :cols="edit ? '9' : '12'" class="pa-0">
          <v-list
            class='pa-0 ma-0 scroll-y scroll-hook'
            :style="contentsHeight"
          >
            <v-row align="center" v-for="i in 4" :key="i" class="pa-0 ma-0">
              <v-col cols="3" d-flex class="pa-0">
                <v-row align="center" class="pa-0 ma-0">
                  <v-col cols="4" d-flex class="pa-0">
                    <v-row align="center" class="pa-0 ma-0">
                      <v-col cols="12" class="pa-0">
                        <v-flex
                          d-flex
                          xs12
                          v-for="n in 7"
                          :key="n" class="px-0">
                          <v-row align="center" class="pa-0 ma-0">
                            <v-col cols="8" class="pa-0">
                              <v-sheet tile :color="checkToday(dd, i, n) ? 'primary' : getWeekColor(n)" :height="height" class="L-R-T">
                                <v-row align="center" justify="center">
                                  <span :class="checkToday(dd, i, n) ? 'white--text' : getWeekColorClass(n)" :style="'padding-top: ' + ((height / 2) - ( 12 / 2) - 2) + 'px;'">{{ getDayOfMonth(month, ((i - 1) * 7) + n) }}</span>
                                </v-row>
                                <span :class="checkToday(dd, i, n) ? 'white--text' : getWeekColorClass(n) + ' font-weight-bold'">{{ $WEEK[n%7] }}</span>
                              </v-sheet>
                            </v-col>
                            <v-col cols="4" class="pa-0 hidden-xs-only">
                              <v-sheet tile :height="height" :style="'padding-top: ' + ((height / 2) - ( 12 / 2) - 2) + 'px;'" color="grey" :class="n == 1 ? 'T' : ''">
                                  <v-row align="center" justify="center">
                                  <span v-if="n == 4" class="title white--text">{{ getType(i) }}</span>
                                </v-row>
                              </v-sheet>
                            </v-col>
                          </v-row>
                        </v-flex>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="8" d-flex class="pa-0">
                    <v-flex
                      d-flex
                      xs12
                      v-for="n in 7"
                      :key="n">
                      <v-sheet
                        tile
                        :color="getWeekColor(n)"
                        :height="height"
                        @dragover="dragover($event, month, ((i - 1) * 7) + n, 0)"
                        @dragenter="dragenter($event, month, ((i - 1) * 7) + n)"
                        @drop="drop($event,0)"
                        @dragleave="dragleave($event)"
                        :style="checkLines(month, ((i - 1) * 7) + n)"
                        @click.right.stop="rClickNone($event)"
                        width="100%"
                        class="L-R-T"
                      >
                        <v-row align="center" justify="center" v-for="item in getEvent(month, ((i - 1) * 7) + n)" :key="item.key">
                          <v-col cols="12" class="py-0" align="center" >
                          <p
                            v-if="item.type == 'holiday'"
                            :style="getEventWidth(item)"
                            class="mb-0 px-0 py-0 text-left">{{ item.title }}
                          </p>
                          <p
                            v-else
                            :style="getEventWidth(item)"
                            draggable="true"
                            @dragstart="dragstart($event, item)"
                            @dragend="dragend($event)"
                            class="mb-0 px-0 text-left"
                            @click="onEditEvent(item)"
                          >
                            {{ item.duration == 1 ? item.title : '⬇︎' + item.title }}
                          </p>
                          </v-col>
                        </v-row>
                      </v-sheet>
                    </v-flex>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="9" class="pa-0">
                <v-row class="pa-0 ma-0" align="center" justify="center">
                  <v-col cols="3" class="pa-0" d-flex v-for="x in 4" :key="x">
                    <v-row class="pa-0 ma-0" align="center" justify="center">
                      <v-flex
                        d-flex
                        xs12
                        v-for="n in 7"
                        :key="n">
                        <v-sheet
                          tile
                          :color="getWeekColor(n)"
                          :height="height"
                          @dragover="dragover($event, month, ((i - 1) * 7) + n, x)"
                          @dragenter="dragenter($event, month, ((i - 1) * 7) + n)"
                          @drop="drop($event,0)"
                          @dragleave="dragleave($event)"
                          @click.right.stop="rClick($event, month, ((i - 1) * 7) + n, x)"
                          style="overflow-x: hidden;"
                          width="100%"
                          class="R-T scroll-y"
                        >
                          <div v-for="item in getTask(month, ((i - 1) * 7) + n, x)" :key="item.key"
                            draggable="true"
                            @dragstart="dragstart($event, item)"
                            @dragend="dragend($event)"
                            @click="onEditEvent(item)"
                            :style="'cursor: pointer;'"
                          >
                            <v-row class="pa-0 ma-0" align="center" justify="center" :key="item.key">
                              <v-col cols="1" class="pa-0" align="center">
                                <v-icon v-if="item.tag" :color="getTagColor(item)" small>mdi-tag</v-icon>
                              </v-col>
                              <v-col cols="6" class="py-0 px-1">
                                <p :style="getTaskColor(item)" class="task-title-tiny text-left">{{ item.title }}</p>
                              </v-col>
                              <v-col cols="4" class="pa-0 px-1" align="center">
                                <template-group-avatar :item="item" :size="16" :height="16"></template-group-avatar>
                              </v-col>
                              <v-col cols="1" class="pa-0" align="center">
                                <v-icon size="14" class="px-0" :color="getCategoryColor(item)">{{ item.status ? $TASK_STATUS[item.status - 1].icon : $TASK_STATUS[0].icon }}</v-icon>
                              </v-col>
                            </v-row>
                          </div>
                        </v-sheet>
                      </v-flex>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-list>
        </v-col>
        <v-col v-if="edit" cols="3" class="pa-0">
          <v-sheet
            class='not-select scroll-y'
            :style="contentsHeight"
          >
            <template v-if="menuSort == 'category'">
              <v-row class="pa-0 ma-0" align="center" justify="center" v-for="description in descriptions" :key="description.key">
                <v-col cols="12" class="pa-1">
                  <v-toolbar flat :color="description.color" dark height="28">
                    <v-toolbar-title class="text-left">
                      <span>{{ description.name }}</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark small icon @click.stop.prevent="description.value = !description.value">
                      <v-icon v-if="description.value">mdi-chevron-up</v-icon>
                      <v-icon v-else>mdi-chevron-down</v-icon>
                    </v-btn>
                  </v-toolbar>
                </v-col>
                <v-col cols="12" class="py-0" align="center">
                  <v-list v-if="description.value" color="transparent">
                    <template v-for="item in taskTemplates">
                      <v-row v-if="checkTemplateCategory(description.key, item)" class="pa-0 ma-0" align="center" justify="center" :key="item.key">
                        <v-col cols="11" class="pa-0" align="center">
                          <div
                            draggable="true"
                            @dragstart="dragstart($event, item)"
                            @dragend="dragend($event)"
                            :style="'cursor: pointer;'"
                          >
                            <v-row class="pa-0 ma-0" align="center" justify="center">
                              <v-col cols="3" class="pa-0">
                                <p :style="getTaskColor(item)" class="task pa-0">{{ getActionName(item) }}</p>
                              </v-col>
                              <v-col cols="9" class="pa-0">
                                <p
                                  :style="getTaskColor(item)"
                                  class="task text-left"
                                  :color="getCategoryColor(item)">
                                  <span>{{ item.title }}</span>
                                </p>
                              </v-col>
                            </v-row>
                          </div>
                        </v-col>
                        <v-col cols="1" class="pa-0">
                          {{ $WEEK_ZONE_TABLE[item.week - 1].name }}
                        </v-col>
                      </v-row>
                    </template>
                  </v-list>
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-row class="pa-0 ma-0" align="center" justify="center" v-for="x in 4" :key="x">
                <v-col cols="12" class="pa-1">
                  <v-toolbar flat dark height="28" color="grey" :key="x">
                    <v-row class="ma-0">
                      <v-col cols="2" class="pa-0">
                        <span class="title">{{ $WEEK_ZONE_TABLE[x - 1].name }}</span>
                      </v-col>
                      <v-col cols="10" class="pa-0 text-right">
                        <span class="title">{{ getDayOfWeekZone(x) }}</span>
                      </v-col>
                    </v-row>
                  </v-toolbar>
                </v-col>
                <v-col cols="12" class="py-0" align="center">
                  <v-list color="transparent" :key="x + 'templates'">
                    <template v-for="item in taskTemplates">
                      <v-row  v-if="checkTemplateDay(x, item)" class="pa-0 ma-0" align="center" justify="center" :key="item.key">
                        <v-col cols="12" class="pa-0" align="center">
                          <div
                            draggable="true"
                            @dragstart="dragstart($event, item)"
                            @dragend="dragend($event)"
                            :style="'cursor: pointer;'"
                          >
                            <v-row class="pa-0 ma-0" align="center" justify="center">
                              <v-col cols="3" class="pa-0">
                                <p :style="getTaskColor(item)" class="task pa-0">{{ getActionName(item) }}</p>
                              </v-col>
                              <v-col cols="9" class="pa-0">
                                <p
                                  :style="getTaskColor(item)"
                                  class="task text-left"
                                  :color="getCategoryColor(item)">
                                  <span>{{ item.title }}</span>
                                </p>
                              </v-col>
                            </v-row>
                          </div>
                        </v-col>
                      </v-row>
                    </template>
                  </v-list>
                </v-col>
              </v-row>
            </template>
          </v-sheet>
        </v-col>
      </v-row>
    </v-col>

    <div>
      <v-dialog v-model="dialog"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <app-task-dialog
          v-if="dialog"
          @dismissed="onDismissed"
          :dialog='dialog'
          :item="item"
          :group="group"
          :tempGroups="tempGroups"
          :year="year"
          :month="month"
          :events="events"
          :tasks="tasks"
          :taskTemplates="taskTemplates"
          type="new"
        >
        </app-task-dialog>
      </v-dialog>
    </div>

    <div class="text-center">
      <v-layout row justify-center>
        <v-dialog
          v-model='eventDialog'
          persistent
          :max-width="'400px'">
          <app-event-edit
            v-if="eventDialog"
            @dismissed="onDismissed"
            :item="item"
            :dialog='eventDialog'
            :event="event"
          >
          </app-event-edit>
        </v-dialog>
      </v-layout>
    </div>

    <div class="text-center">
      <v-layout row justify-center>
        <v-dialog
          v-model='taskDialog'
          persistent
          :max-width="'400px'">
          <app-task-edit
            v-if="taskDialog"
            @dismissed="onDismissed"
            :item="item"
            :dialog='taskDialog'
            :task="task"
          >
          </app-task-edit>
        </v-dialog>
      </v-layout>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import Moment from 'moment-timezone'
import { extendMoment } from 'moment-range'
const moment = extendMoment(Moment)
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      tags: 'tags/tags',
      scheduleEvents: 'scheduleEvents/events',
      templateEvents: 'templateEvents/templates',
      windowSize: 'shared/windowSize'
    }),
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 23 - 40) + 'px;'
    }
  },
  data () {
    return {
      loading: false,
      height: 160,
      dialog: false,
      taskDialog: false,
      eventDialog: false,
      event: null,
      descriptions: [],
      task: null,
      y: true,
      base: null,
      item: null,
      school: null,
      dd: 0,
      revent: {},
      menuItems: [
        { title: '種別順', value: 'category' },
        { title: '時間順', value: 'time' }
      ],
      menuSort: 'time'
    }
  },
  props: [ 'edit', 'year', 'month', 'group', 'tempGroups', 'add', 'events', 'tasks', 'eventTemplates', 'taskTemplates', 'lines', 'type' ],
  watch: {
    add () {
      if (this.add) {
        this.item = JSON.parse(JSON.stringify(this.$store.getters['scheduleEvents/initial']))
      } else {
        this.item = null
      }
      this.dialog = this.add
    }
  },
  created () {
    this.wait()
    this.descriptions = JSON.parse(JSON.stringify(this.$DESCRIPTIONS_ITEMS))
    var keys = Object.keys(this.data.schools)
    for (var i in keys) {
      if (this.data.schools[keys[i]]) {
        var index = this.schools.findIndex(school => school.key === keys[i])
        if (index !== -1) {
          this.school = this.schools[index]
        }
      }
    }
  },
  methods: {
    async wait () {
      this.loading = true
      const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
      await pause(100).then(() => {
        this.loading = false
      })
    },
    checkToday (dd, i, n) {
      if (this.year !== this.getFY()) {
        return false
      }
      moment.tz.setDefault('Asia/Tokyo')
      var day = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).day()
      // day = day === 6 ? -1 : day
      if (day === 0) {
        day = 7
      } else if (day === 1) {
        day = 8
      }
      if (this.month !== parseInt(((moment().diff(moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).add(1 - day, 'd'), 'days')) / 28)) + 1) {
        return false
      }
      return dd + 1 === ((i - 1) * 7) + n
    },
    onGotoToday () {
      moment.tz.setDefault('Asia/Tokyo')
      var day = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).day()
      // day = day === 6 ? -1 : day
      if (day === 0) {
        day = 7
      } else if (day === 1) {
        day = 8
      }
      this.dd = (moment().diff(moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).add(1 - day, 'd'), 'days') % 28)
      this.$nextTick(() => {
        var container = this.$el.querySelector('.scroll-hook')
        if (container) {
          const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
          pause(10).then(() => {
            if (this.month === parseInt(((moment().diff(moment([this.year, 3, 1]), 'days')) / 28)) + 1) {
              container.scrollTop = ((this.height + 2) * this.dd) - 32
            } else {
              container.scrollTop = 0
            }
          })
        }
      })
    },
    rClickNone (e) {
      e.preventDefault()
    },
    rClick (e, mm, dd, x) {
      e.preventDefault()
      if (this.getPrivilegesLevel(this.data) > 2) {
        return
      }
      if (this.year === this.getFY()) {
        var date = this.getDay(this.year, mm, dd)
        var start = moment(date, 'YYYY-MM-DD')
        var end = moment(date, 'YYYY-MM-DD')
        this.item = JSON.parse(JSON.stringify(this.$store.getters['scheduleTasks/initial']))
        this.item.schools[this.school.key] = true
        this.item.startDate = start.format('YYYY-MM-DD')
        this.item.start = {
          date: start.format('YYYY-MM-DD'),
          yyyy: parseInt(start.format('YYYY')),
          mm: parseInt(start.format('MM')),
          dd: parseInt(start.format('DD'))
        }
        this.item.endDate = end.format('YYYY-MM-DD')
        this.item.end = {
          date: end.format('YYYY-MM-DD'),
          yyyy: parseInt(end.format('YYYY')),
          mm: parseInt(end.format('MM')),
          dd: parseInt(end.format('DD'))
        }
        this.item.category = x
        this.task = 'task'
        this.taskDialog = true
      }
    },
    dragstart (e, item) {
      this.dragitem = JSON.parse(JSON.stringify(item))
      this.dragto = null
    },
    drop (e) {
      e.target.style.opacity = 1
      var item = null
      if (this.dragitem.type === 'event' && this.dragto.x !== 0) {
        this.dragitem = this.dragto = null
        e.stopPropagation()
        e.preventDefault()
        return
      }
      if (this.dragitem.type === 'task' && this.dragto.x !== this.dragitem.category) {
        this.dragitem = this.dragto = null
        e.stopPropagation()
        e.preventDefault()
        return
      }
      if (this.dragitem.type === 'template' && this.dragto.x !== this.dragitem.category) {
        this.dragitem = this.dragto = null
        e.stopPropagation()
        e.preventDefault()
        return
      }
      var date = this.getDay(this.year, this.dragto.mm, this.dragto.dd)
      var start = moment(date, 'YYYY-MM-DD')
      var end = moment(date, 'YYYY-MM-DD')
      if (this.dragitem.type === 'event') {
        item = JSON.parse(JSON.stringify(this.dragitem))
        if (this.dragitem.duration !== 1) {
          end.add(this.dragitem.duration, 'days')
        }
        item.duration = this.dragitem.duration
      } else if (this.dragitem.type === 'task') {
        item = JSON.parse(JSON.stringify(this.dragitem))
        end.add(this.dragitem.duration - 1, 'days')
      } else {
        // if (this.year === this.getFY()) {
        this.item = JSON.parse(JSON.stringify(this.$store.getters['scheduleTasks/initial']))
        this.item.template = this.dragitem.key
        this.item.schools[this.school.key] = true
        this.item.startDate = start.format('YYYY-MM-DD')
        this.item.start = {
          date: start.format('YYYY-MM-DD'),
          yyyy: parseInt(start.format('YYYY')),
          mm: parseInt(start.format('MM')),
          dd: parseInt(start.format('DD'))
        }
        this.item.endDate = end.format('YYYY-MM-DD')
        this.item.end = {
          date: end.format('YYYY-MM-DD'),
          yyyy: parseInt(end.format('YYYY')),
          mm: parseInt(end.format('MM')),
          dd: parseInt(end.format('DD'))
        }
        this.task = 'task'
        this.taskDialog = true
        // }
        this.dragitem = this.dragto = null
        e.stopPropagation()
        e.preventDefault()
      }
      // item.startDate = start.format('YYYY-MM-DD')
      // item.start = {
      //   date: start.format('YYYY-MM-DD'),
      //   yyyy: parseInt(start.format('YYYY')),
      //   mm: parseInt(start.format('MM')),
      //   dd: parseInt(start.format('DD'))
      // }
      // item.endDate = end.format('YYYY-MM-DD')
      // item.end = {
      //   date: end.format('YYYY-MM-DD'),
      //   yyyy: parseInt(end.format('YYYY')),
      //   mm: parseInt(end.format('MM')),
      //   dd: parseInt(end.format('DD'))
      // }
      // item.schools[this.school.key] = true
      // this.storeEvent(item)
      // this.dragitem = this.dragto = null
      // e.stopPropagation()
      // e.preventDefault()
    },
    dragend (e) {
      e.target.style.opacity = 1
      e.preventDefault()
      this.dragitem = this.dragto = null
    },
    dragover (e, mm, dd, x) {
      e.preventDefault()
      this.dragto = { mm: mm, dd: dd, x: x }
    },
    dragenter (e, x, i) {
      e.preventDefault()
      e.target.style.opacity = 0.5
    },
    dragleave (e) {
      e.preventDefault()
      e.target.style.opacity = 1
    },
    getMonth (mm) {
      var m = mm + 3
      if (m > 13) {
        m -= 13
      }
      return m
    },
    getDayOfMonth (mm, dd) {
      // var diff = 0
      // var date = new Date(String(parseInt(this.year) + '/' + '4' + '/' + '1'))
      // var firstDay = date.getDay()
      // if (firstDay > 1) {
      //   diff = 8 - firstDay
      // } else {
      //   diff = 1 - firstDay
      // }
      // moment.tz.setDefault('Asia/Tokyo')
      // var d = new Date(String(parseInt(this.year) + '/' + '4' + '/' + String(parseInt('1') + diff)))
      // d.setDate(d.getDate() + (((mm - 1) * 28) + (dd - 1)))
      // var m = moment(d)
      // return m.format('MM/DD')
      moment.tz.setDefault('Asia/Tokyo')
      var day = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).day()
      // day = day === 6 ? -1 : day
      if (day === 0) {
        day = 7
      } else if (day === 1) {
        day = 8
      }
      return moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).add(1 - day + ((mm - 1) * 28) + (dd - 1), 'd').format('MM/DD')
    },
    getDayOfWeekZone (zone) {
      // var diff = 0
      // var date = new Date(String(parseInt(this.year) + '/' + '4' + '/' + '1'))
      // var firstDay = date.getDay()
      // if (firstDay > 1) {
      //   diff = 8 - firstDay
      // } else {
      //   diff = 1 - firstDay
      // }
      var dd = ((zone - 1) * 7) + 1
      // moment.tz.setDefault('Asia/Tokyo')
      // var d = new Date(String(parseInt(this.year) + '/' + '4' + '/' + String(parseInt('1') + diff)))
      // d.setDate(d.getDate() + (((this.month - 1) * 28) + (dd - 1)))
      // var start = moment(d)
      // var end = moment(d).add(6, 'd')
      // return start.format('MM/DD') + ' - ' + end.format('MM/DD')
      moment.tz.setDefault('Asia/Tokyo')
      var day = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).day()
      // day = day === 6 ? -1 : day
      if (day === 0) {
        day = 7
      } else if (day === 1) {
        day = 8
      }
      var start = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).add(1 - day + ((this.month - 1) * 28) + (dd - 1), 'd').format('MM/DD')
      var end = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).add(1 - day + ((this.month - 1) * 28) + (dd - 1) + 6, 'd').format('MM/DD')
      return start + ' - ' + end
    },
    getTagColor (item) {
      if (item.tag) {
        var index = this.tags.findIndex(t => t.key === item.tag)
        if (index !== -1) {
          return this.tags[index].color
        }
      }
      return 'grey'
    },
    getTaskColor (item) {
      const bg = 'background-color: ' + this.getDescriptionColor(item, this.$COLOR_LIGHT) + '; '
      const border = 'border: 1px solid ' + this.getDescriptionColor(item, this.$COLOR_DEFAULT) + '; '
      const font = 'color: ' + this.getDescriptionColor(item, this.$COLOR_DARK) + '; '
      return bg + border + font
    },
    getEventWidth (item) {
      var s = ''
      s = 'width: 90%; ' + 'height: 16px;'
      s += ' font-size:10px; cursor: pointer; padding-left: 6px !important; padding-right: 2px !important;'
      s += ' background-color: ' + this.getDescriptionColor(item) + ';'
      return s
    },
    getActionName (item) {
      var index = this.$ACTION_TABLE.findIndex(a => a.key === item.action)
      if (index !== -1) {
        return this.$ACTION_TABLE[index].name
      }
      return 'N/A'
    },
    getEvent (mm, dd) {
      // var diff = 0
      // var date = new Date(String(parseInt(this.year) + '/' + '4' + '/' + '1'))
      // var firstDay = date.getDay()
      // if (firstDay > 1) {
      //   diff = 8 - firstDay
      // } else {
      //   diff = 1 - firstDay
      // }
      // moment.tz.setDefault('Asia/Tokyo')
      // var d = new Date(String(parseInt(this.year) + '/' + '4' + '/' + String(parseInt('1') + diff)))
      // d.setDate(d.getDate() + (((mm - 1) * 28) + (dd - 1)))
      moment.tz.setDefault('Asia/Tokyo')
      var day = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).day()
      // day = day === 6 ? -1 : day
      if (day === 0) {
        day = 7
      } else if (day === 1) {
        day = 8
      }
      var date = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).add(1 - day + ((mm - 1) * 28) + (dd - 1), 'd').format('YYYY/MM/DD')
      var year = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).add(1 - day + ((mm - 1) * 28) + (dd - 1), 'd').year()
      var d = new Date(date)
      var events = []
      if (moment(d).month() < 3 && this.year === year) {
        var temp = this.scheduleEvents.filter(function (event) {
          if (moment(d).format('YYYY-MM-DD') === event.startDate) {
            return true
          }
          return false
        })
        for (var e in temp) {
          var etemp = JSON.parse(JSON.stringify(temp[e]))
          var index = this.templateEvents.findIndex(template => template.key === etemp.template)
          if (index !== -1) {
            etemp['category'] = this.templateEvents[index].category
            etemp['title'] = this.templateEvents[index].title
            etemp['description'] = this.templateEvents[index].description
            etemp['period'] = this.templateEvents[index].period
            etemp['schools'] = this.templateEvents[index].schools
          } else {
            etemp['category'] = null
            etemp['title'] = null
            etemp['description'] = null
            etemp['period'] = 1
            etemp['groups'] = {}
            etemp['schools'] = {}
          }
          events.push(etemp)
        }
      } else {
        var m = moment(d).month() < 3 ? moment(d).month() + 9 : moment(d).month() - 3
        for (var i in this.events[m][moment(d).date() - 1]) {
          var event = JSON.parse(JSON.stringify(this.events[m][moment(d).date() - 1][i]))
          if (event.type === 'event') {
            if (event.groups['*']) {
              events.push(event)
            } else if (event.groups[this.group]) {
              events.push(event)
            }
          } else {
            events.push(event)
          }
        }
      }
      return events
    },
    getTask (mm, dd, category) {
      var temp = JSON.parse(JSON.stringify(this.tasks[mm - 1][dd - 1]))
      var tasks = []
      for (var i in temp) {
        if (temp[i].category === this.$DESCRIPTIONS_ITEMS[category - 1].key) {
          if (this.group === '*') {
            tasks.push(temp[i])
          } else if (temp[i].groups[this.group]) {
            tasks.push(temp[i])
          }
        }
      }
      return tasks
    },
    getCharge (item) {
      var index = this.users.findIndex(u => u.key === item.charge)
      if (index !== -1) {
        return this.users[index].sei
      }
      return ''
    },
    checkLines (mm, dd) {
      // var diff = 0
      // var date = new Date(String(parseInt(this.year) + '/' + '4' + '/' + '1'))
      // var firstDay = date.getDay()
      // if (firstDay > 1) {
      //   diff = 8 - firstDay
      // } else {
      //   diff = 1 - firstDay
      // }
      // moment.tz.setDefault('Asia/Tokyo')
      // var d = new Date(String(parseInt(this.year) + '/' + '4' + '/' + String(parseInt('1') + diff)))
      // d.setDate(d.getDate() + (((mm - 1) * 28) + (dd - 1)))
      moment.tz.setDefault('Asia/Tokyo')
      var day = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).day()
      // day = day === 6 ? -1 : day
      if (day === 0) {
        day = 7
      } else if (day === 1) {
        day = 8
      }
      var date = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).add(1 - day + ((mm - 1) * 28) + (dd - 1), 'd').format('MM/DD')
      var d = new Date(date)
      var m = moment(d).month() < 3 ? moment(d).month() + 9 : moment(d).month() - 3
      if (this.lines[m][moment(d).date() - 1].length !== 0) {
        return 'border-left: 1px solid ' + this.getDescriptionColor(this.lines[m][moment(d).date() - 1][0]) + ' !important;'
      }
      return ''
    },
    checkTemplateDay (x, item) {
      if ((item.month === 0 || this.month === item.month) && x === item.week) {
        return true
      }
      return false
    },
    checkTemplateCategory (key, item) {
      if (item.category === key && this.checkMonth(item)) {
        return true
      }
      return false
    },
    checkMonth (item) {
      return this.month === item.month || item.month === 0
    },
    thisMonth () {
      var m = new Date().getMonth() + 1
      return m
    },
    getType (i) {
      return this.$WEEK_ZONE_TABLE[parseInt(i) - 1].name
    },
    onMenu (item) {
      this.menuSort = item.value
    },
    onChangeCategory () {
      this.menuSort = this.menuSort === 'category' ? 'time' : 'category'
    },
    onEditEvent (item) {
      if (this.type && this.type === 'dialog') {
        this.$emit('change', { item: JSON.parse(JSON.stringify(item)) })
      } else {
        this.item = JSON.parse(JSON.stringify(item))
        if (item.type === 'event') {
          this.event = 'event'
          this.eventDialog = true
        } else {
          this.task = 'task'
          this.taskDialog = true
        }
      }
    },
    onPrint () {
      window.print()
    },
    onDismissed () {
      if (this.taskDialog) {
        this.taskDialog = false
        return
      }
      if (this.rClickDialog) {
        this.rClickDialog = false
        return
      }
      this.taskDialog = false
      this.eventDialog = false
      this.$emit('dismissed')
    },
    storeEvent (item) {
      var vm = this
      vm.loading = true
      var path = item.type === 'event' ? 'scheduleEvents/write' : 'scheduleTasks/write'
      this.$nextTick(function () {
        var payload = JSON.parse(JSON.stringify(item))
        if (item.key) {
          payload.updatedAt = parseInt(new Date().getTime())
        } else {
          payload.createdAt = payload.updatedAt = parseInt(new Date().getTime())
        }
        vm.$store.dispatch(path, JSON.parse(JSON.stringify(payload))).then((resp) => {
          vm.loading = false
        })
      })
    }
  }
}
</script>

<style scoped>

p.task {
  white-space: nowrap;
  overflow: hidden;
  border-radius: 0px;
  line-height: 16px;
  font-size: 12px !important;
}

p.task-title-tiny {
  font-size: 11px !important;
  line-height: 16px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 0px;
  padding: 0px !important;
  padding-left: 6px !important;
  margin: 0px !important;
}

p.charge {
  white-space: nowrap;
  overflow: hidden;
  border-radius: 8px;
  padding: 0px;
  margin: 2px;
  line-height: 16px;
}

p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: aqua;
  border-radius: 8px;
  padding-left: 6px;
  line-height: 16px;
  margin: 2px;
  color: aliceblue;
  user-select: none;
}

span {
  user-select: none;
}

::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 8px;
}
::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: rgba(0,0,0,.5);
    box-shadow: 0 0 1px rgba(255,255,255,.3);
}

.not-select {
  user-select: none;
}

::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 4px;
}
::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: rgba(0,0,0,.5);
    box-shadow: 0 0 1px rgba(255,255,255,.3);
}

</style>
